module.exports = __webpack_public_path__ + "components/country-flag/static/kr-99382bbb9127fae5992cf998ae673281.svg";